var getCurrentCityName = function () {
  return new Promise(function (resolve, reject) {
    var myCity = new BMap.LocalCity()
    myCity.get(function (result) {
      resolve(result)
    })
  })
}

export default getCurrentCityName


//////////////////
// WEBPACK FOOTER
// ./static/js/getUserLocation.js
// module id = GqHn
// module chunks = 17